import React from "react";
import Hero from "../components/Partners/Hero";
 
import PartnerSect from "../components/Partners/partnerSection";
import PartnerCard from "../components/Partners/PartnerCard";
import { Helmet } from 'react-helmet-async';
const Partner = () => {
    return (
        <>
            {/*metadata for SEO */}
            <Helmet>
                <title>DevAngles: Google Cloud Partner & Nasscom Member | IT Services</title>
                <meta name="description" content="DevAngles, a certified Google Cloud Partner & proud Nasscom member, delivers cutting-edge cloud solutions & industry-standard IT services. Partner with us for trusted digital transformation." />

                <link rel="canonical" href="https://www.devangles.com/alliance/" />
                <link rel="dns-prefetch" href="https://www.devangles.com" />
                <link rel="dns-prefetch" href="//fonts.googleapis.com" />
            </Helmet>
            <Hero />
            
            {/* <PartnerSect /> */}
            <PartnerCard />
        </>
    );
};

export default Partner;